import React from "react";
import {
  ResponsiveContainer,
  ComposedChart,
  Tooltip,
  Bar,
  XAxis,
  LabelList,
  Line,
} from "recharts";
import "./index.css";

const monthData = {
  1: "Enero",
  2: "Febrero",
  3: "Marzo",
  4: "Abril",
  5: "Mayo",
  6: "Junio",
  7: "Julio",
  8: "Agosto",
  9: "Septiembre",
  10: "Octubre",
  11: "Noviembre",
  12: "Diciembre",
};

let TryIdentificador = "1";

function formatCompact(value) {
  if (TryIdentificador === "2") return value;

  const result = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
  return result;
}

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    console.log(payload[0]["payload"].venta);
    return (
      <div
        className="custom-tooltip"
        style={{
          padding: 8,
        }}
      >
        <p>{`${label}`}</p>
        <p style={{ color: "#8884D8" }}>{`  Venta: ${formatCompact(
          payload[0]["payload"].venta
        )}`}</p>
        {payload[0]["payload"].ventaAnioAnterior && (
          <p
            style={{
              color: "#84d4d8",
            }}
          >
            {`  Venta Año Anterior: ${formatCompact(
              payload[0]["payload"].ventaAnioAnterior
            )}`}
          </p>
        )}
        <p style={{ color: "#FF7300" }}>{`  Promedio : ${formatCompact(
          payload[0]["payload"].promedio
        )}`}</p>
      </div>
    );
  }

  return null;
};

const renderCustomizedLabel = (props) => {
  const { x, y, width, value } = props;
  const radius = 5;
  return (
    <g>
      <text
        x={x + width / 2}
        y={y - radius}
        fill="#8094ae"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        {formatCompact(value)}
      </text>
    </g>
  );
};

function GenerateBarChart({ dataMonth, sucursal, promedio, lastYearMonth }) {
  const rebuildDataV2 = () => {
    const newData = dataMonth.map((item, index) => {
      const month = monthData[item.mes]; // Get the month name
      const venta = item.venta ?? 0; // Get the venta value

      return {
        name: month,
        venta: venta,
        ventaAnioAnterior: lastYearMonth[index].venta ?? 0,
        promedio: promedio ?? 0,
      };
    });
    return newData;
  };

  return (
    <ResponsiveContainer width="100%" height="50%">
      <ComposedChart
        data={rebuildDataV2()}
        className="new-bar-chart"
        margin={{
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        }}
      >
        <Tooltip content={<CustomTooltip />} />
        <XAxis dataKey="name" />\
        <Bar dataKey="venta" fill="#8884d8">
          <LabelList
            dataKey="venta"
            position="top"
            content={renderCustomizedLabel}
          />
        </Bar>
        <Bar dataKey="ventaAnioAnterior" fill="#84d4d8">
          
        </Bar>
        <Line type="monotone" dataKey="promedio" stroke="#ff7300" />
      </ComposedChart>
    </ResponsiveContainer>
  );
}

function GenerateDispersionChart({ dataDay, promedio }) {
  const formatData = () => {
    const newData = [];

    for (let day = 1; day <= 31; day++) {
      const item = dataDay.find((data) => data.dia === day);
      const venta = item ? item.venta : 0;

      newData.push({
        name: day,
        venta: venta,
        promedio: promedio ?? 0,
      });
    }

    return newData;
  };

  return (
    <ResponsiveContainer width="100%" height="50%">
      <ComposedChart
        data={formatData()}
        className="new-line-chart"
        margin={{
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        }}
      >
        <Tooltip content={<CustomTooltip />} />
        <XAxis dataKey="name" />
        <Line type="monotone" dataKey="venta" stroke="#8884d8" />
        <Line type="monotone" dataKey="promedio" stroke="#ff7300" />
      </ComposedChart>
    </ResponsiveContainer>
  );
}

export default function index({ data, type, identificador }) {
  if (data === undefined) return <div>Data not found</div>;

  TryIdentificador = identificador;

  return (
    <div
      className="dp-chart-container"
      style={{
        height: "500px",
      }}
    >
      <div className="title-card-chart">
        <p>
          {data[1].unidad}
          <span> {type}</span>
        </p>
      </div>

      <div className="dp-new-chart">
        <div>
          <p>
            {data[1].Mes_actual}
            <span>{data[1].Os_mes_actual}</span>
          </p>
          <p></p>
        </div>

        <div>
          <p>
            {data[1].Mes_pasado}
            <span>{data[1].Os_mes_pasado}</span>
          </p>
        </div>

        <div>
          <p>
            {data[1].Mes_anio_anterior}
            <span>{data[1].OS_mes_anio_anterior}</span>
          </p>
        </div>
      </div>

      <div className="dp-new-chart">
        <hr></hr>
        <div>
          <p>
            TEMOC
            <span>{data[1].Temoc}</span>
          </p>
          <p></p>
        </div>

        <div>
          <p>
            TEMOF
            <span>{data[1].Temof}</span>
          </p>
        </div>

        <div></div>
      </div>

      <div className="dp-charts-container">
        <GenerateDispersionChart
          dataDay={data[1].Os_publico}
          promedio={data[1].Os_promedio_mes}
        />

        <GenerateBarChart
          dataMonth={data[1].Os_publico_anio}
          lastYearMonth={data[1].Os_publico_anio_ant}
          sucursal={data[1].unidad}
          promedio={data[1].Os_promedio_anio}
        />
      </div>
    </div>
  );
}
